module.exports = __webpack_public_path__ + "static/media/metop_lib.a717a368.png";